import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'
import { checkAvailableForSubmitBtn } from 'helpers'

export default class extends Controller {
  static targets = [ 'submitBtn', 'sndform']

  connect() {
    // checkAvailableForSubmitBtn($(this.submitBtnTarget))
    // $(this.submitBtnTarget).closest('form').on("change", () => {
    //   checkAvailableForSubmitBtn($(this.submitBtnTarget))
    // })
  }

  submitBtnTargetConnected(e) {
    checkAvailableForSubmitBtn($(this.submitBtnTarget))
    $(this.submitBtnTarget).closest('form').on("change", () => {
      checkAvailableForSubmitBtn($(this.submitBtnTarget))
    })
  }

  sndformTargetConnected(form) {

    let formHasChanges = false;

    for (let i = 0; i < form.elements.length; i++) {
      const el = form.elements[i]

      if (el.disabled) continue;

      // Track touched
      el.addEventListener('blur', () => {
        el.dataset.touched = "true";
      });

      // Track dirty
      ['input', 'change'].forEach(eventType => {
        el.addEventListener(eventType, () => {
          switch (el.type) {
            case 'checkbox':
            case 'radio':
              el.dataset.dirty = el.checked !== el.defaultChecked ? "true" : "false";
              break;
        
            case 'select-one':
            case 'select-multiple':
              const isDirty = Array.from(el.options).some(
                opt => opt.selected !== opt.defaultSelected
              );
              el.dataset.dirty = isDirty ? "true" : "false";
              break;
        
            default:
              el.dataset.dirty = el.value !== el.defaultValue ? "true" : "false";
          }

          if(el.dataset.dirty == "true" && !formHasChanges) {
            formHasChanges = true
          }
        });
      });
    };

    if(formHasChanges) {
      form.dataset.dirty = "true"
    }
  }
}
